///<reference path='../config.ts' />
"use strict"

module agi.expressions.card.manifest {
    export class AssetManifest {
        public sheetUrls:Array<string>;
        public audioUrls:Array<Array<string>>; 
        public desktopMenuUrls:any;
        public closeButtonUrl:string;
        public endScreenUrl:string; 
        public loaderGIF:string;
        public sfxData:IHowlProperties;
        public musicData:IHowlProperties;
        public playButtonURLs:{receiver:string, sender:string, end:string}
        public menuAssets:any;
        public butterflyReveal:any;
        public leaveTweensData:any;
        public ui:any;
        public pumpkin:any;
        public carve:any;
        public bat:Array<string>;
        public magic:Array<string>;

        constructor (assetPath:string){
            this.sheetUrls  = [
                assetPath + 'images/sprites0.json'
            ];
            this.audioUrls = [[
                assetPath + "audio/music.m4a",
                assetPath + "audio/music.mp3",
                assetPath + "audio/music.ogg",
                assetPath + "audio/music.ac3"
                ],
                [
                assetPath + "audio/soundeffects.m4a",
                assetPath + "audio/soundeffects.mp3",
                assetPath + "audio/soundeffects.ogg",
                assetPath + "audio/soundeffects.ac3"
            ]];
            
            this.desktopMenuUrls  = {
                frame: assetPath + 'images/desktopframe.png',
                closeButton: assetPath + 'images/closebutton.png',
                replayButton: assetPath + 'images/replaybutton.png',
                audioOnButton: assetPath + 'images/audioonbutton.png',
                audioOffButton: assetPath + 'images/audiooffbutton.png',
                sendButton: assetPath + 'images/sendbutton.png'
            };

            this.sfxData = {
                src : this.audioUrls[1],
                sprite: {
                    "sfx1": [
                      0,
                      6000
                    ],
                    "sfx2": [
                      7000,
                      1625.0113378684805
                    ]
                }
            };

            this.musicData = {
                src : this.audioUrls[0],
                loop: true,
                sprite: {
                    "loop": [
                      0,
                      31246.009070294785
                    ]
                }
            };

            this.playButtonURLs = {
                sender: assetPath + 'images/play.png',
                receiver: assetPath + 'images/play.png',
                end: assetPath + 'images/end.png'
            }

            this.ui = {
                replayButton: 'UI/replay.png', 
                instruction: 'UI/instruction.png',
                hint: 'UI/hint.png',
                arrow: 'UI/arrow.png',
                tapPumpkin: 'UI/clickhint.png',
                copy:'halloween_tag.png'
            }

            this.pumpkin = {
                pumpkin: 'Pumpkin/pumpkin.png', 
                candle: 'Pumpkin/pumpkin_candle.png',
                inside: 'Pumpkin/pumpkin_inside.png',
                dark: 'Pumpkin/pumpkin_inside_dark.png',
                leaves: 'Pumpkin/leaves.png'                
            }

            this.carve={
                cake: 'Pumpkin/carve_cake.png',
                present: 'Pumpkin/carve_present.png',
                butterfly: 'Pumpkin/carve_butterfly.png',
                cat:'Pumpkin/carve_cat.png',
                face:'Pumpkin/carve_face.png',
                house:'Pumpkin/carve_house.png',
                spider:'Pumpkin/carve_spider.png'
            }

            this.bat=[
                "Bat/bat0001.png",
                "Bat/bat0002.png",
                "Bat/bat0003.png",
                "Bat/bat0004.png",
                "Bat/bat0005.png",
                "Bat/bat0006.png"
            ];

            this.magic=[
                "Magic/fireball0001.png",
                "Magic/fireball0002.png",
                "Magic/fireball0003.png",
                "Magic/fireball0004.png",
                "Magic/fireball0005.png",
                "Magic/fireball0006.png",
                "Magic/fireball0007.png",
                "Magic/fireball0008.png"
            ];

            this.menuAssets = {
                replayButton: 'Menu/menu_startover.png',
                openButton: 'Menu/menu_menu.png',
                closeButton: 'Menu/menu_close.png',
                fullscreenCloseButton: 'Menu/menu_exit.png',
                muteSoundButton: 'Menu/menu_mute.png',
                unMuteSoundButton: 'Menu/menu_unmute.png',
                sendButton: 'Menu/menu_send.png',
            }

            this.closeButtonUrl = assetPath + 'images/end.png';
            this.loaderGIF = assetPath + 'images/bma.gif';

            this.butterflyReveal = {
                itemAnimationStatesTextureData: {
                    purple: {
                        rest : {
                            framePrefixId : 'Butterfly_Purple/Rest/butterfly_purple_rest',
                            nFrames : 19
                        },
                        leave : {
                            framePrefixId : 'Butterfly_Purple/Flap/butterfly_purple_flap',
                            nFrames : 40
                        },
                        shadow : {
                            framePrefixId : 'Shadow/Butterfly_Shadow_Flap',
                            nFrames : 40
                        },
                        glow : {
                            framePrefixId : 'Glow/Butterfly_Glow',
                            nFrames : 19
                        }
                    },
                    orange: {
                        rest : {
                            framePrefixId : 'Butterfly_Orange/Rest/butterfly_orange_rest',
                            nFrames : 19
                        },
                        leave : {
                            framePrefixId : 'Butterfly_Orange/Flap/butterfly_orange_flap',
                            nFrames : 40
                        },
                        glow : {
                            framePrefixId : 'Glow/Butterfly_Glow',
                            nFrames : 19
                        }
                    }
                },
                positioningData: {
                    purple: [
                        [174.6, 342.15, 0.8399810791015625, 21.980255126953125],
                        [386, 287.8, 0.910125732421875, 159.9746551513672],
                        [476.25, 533.8, 1.1164093017578125, 89.068115234375],
                        [644.45, 450.25, 0.48028564453125, 66.13185119628906],
                        [-47.25, 448, 0.726715087890625, -174.00096130371094],
                        [211.8, 457.6, 0.7267303466796875, 2.268402099609375],
                        [783.8, 664.45, 0.8219146728515625, 175.26095581054688],
                        [546.6, 353.6, 0.86083984375, 157.5208282470703],
                        [477.35, 689.3, 0.84051513671875, -179.39065551757812],
                        [338.25, 511.25, 0.9571990966796875, -164.31971740722656],
                        [569.4, 778.35, 0.8404541015625, -0.89080810546875],
                        [711.4, 134.65, 0.840484619140625, 63.82232666015625],
                        [740.65, 502.55, 0.972869873046875, 132.78598022460938],
                        [533.25, 146.15, 0.97283935546875, 86.36183166503906],
                        [307.15, 188.25, 0.826904296875, 51.883209228515625],
                        [201.1, 108.85, 0.972869873046875, -137.6288604736328],
                        [239.2, 657.55, 1.0552520751953125, -39.137939453125],
                        //[256.3, 848.1, 1.0050201416015625, -81.79904174804688],
                        [699.5, 281.2, 0.972900390625, 146.7709503173828],
                        [360.95, 19.1, 0.9933929443359375, -174.1826171875],
                        [8.1, 24.5, 0.8701934814453125, 36.90116882324219],
                        [68.45, 595.3, 1.1164093017578125, -22.453781127929688],
                        [37.3, 361.1, 0.7264862060546875, 172.9989776611328],
                        [-22.85, 168.75, 1.1470184326171875, -146.84503173828125]
                    ],
                    orange: [
                        [278.7, 378.25, 0.88079833984375, -58.04365539550781],
                        [141.9, 407.8, 0.519775390625, -41.645111083984375],
                        [723.7, 378.35, 0.84283447265625, 129.91757202148438],
                        [67.35, 131.3, 0.8118133544921875, 153.56097412109375],
                        [126.05, -35.15, 0.8117828369140625, -63.399993896484375],
                        [307.55, 86.25, 0.6812896728515625, 9.214889526367188],
                        [533.45, 13.45, 0.824188232421875, 162.3533477783203],
                        [768.6, 29.75, 0.924163818359375, 139.42337036132812],
                        [7.1, 519.9, 0.824127197265625, -2.658477783203125],
                        [78.2, 281.95, 0.6218719482421875, -177.2856903076172],
                        [401.65, 146.75, 0.8241729736328125, 130.1727294921875],
                        [138.9, 772.2, 0.685577392578125, -5.389617919921875],
                        [622.55, 185.5, 0.9523773193359375, -101.28202819824219],
                        [580.65, 445.1, 0.9141693115234375, 83.42481994628906],
                        [576.15, 595, 0.9141998291015625, -106.53483581542969],
                        [651.75, 656.85, 0.9497528076171875, -68.50857543945312],
                        [716.3, 767.8, 0.669036865234375, 168.7205047607422],
                        //[493.25, 821.05, 0.8952789306640625, 35.98527526855469],
                        //[360.05, 809.15, 0.9400177001953125, 115.94627380371094],
                        [66.75, 723.25, 0.88983154296875, 150.147216796875],
                        [192.15, 594.8, 0.7936248779296875, -68.17704772949219],
                        [375.95, 381.2, 0.9060516357421875, 139.7777862548828],
                        [439, 392.6, 0.82421875, -62.325469970703125],
                        [220.85, 266.9, 0.8860321044921875, -15.978073120117188],
                        [141.6, 197.15, 0.794342041015625, 179.96066284179688],
                        [79.7, 453.2, 0.8241729736328125, 53.713653564453125],
                        [649.25, 30.15, 0.82415771484375, -67.34117126464844],
                        [225, -10.7, 0.824188232421875, -68.44728088378906],
                        [348.7, 666.25, 1.0264892578125, -72.75436401367188],
                        [484.35, 236.2, 0.961578369140625, 40.236480712890625]
                    ],
                    butterflyButton: [
                        [375, 425, 1, 111.7268]
                    ]
                }
            };

            // leave tween data
            //============flight path 1=================
            this.leaveTweensData = [[],[],[],[],[]];
            this.leaveTweensData[0].push(
                {
                    duration:0.01,
                    vars:{
                        x:0,
                        y:0,
                        rotation:0,
                        ease:Linear.easeNone
                    },
                }
            );
            this.leaveTweensData[0].push(
                {
                    duration:0.292,
                    vars:{
                        rotation:.147,
                        ease:Sine.easeInOut
                    },
                }
            );
            this.leaveTweensData[0].push(
                {
                    duration:0.625,
                    vars:{
                        x:173,
                        y:-338,
                        rotation:.37,
                        scaleX:1.33,
                        scaleY:1.30,
                        ease:Sine.easeIn
                    },
                }
            );
            this.leaveTweensData[0].push(
                {
                    duration:1.667,
                    vars:{
                        x:848,
                        y:-2080,
                        scaleX:1.42,
                        scaleY:1.67,
                        ease:Linear.easeIn
                    },
                }
            );
            //============flight path 2=================
            this.leaveTweensData[1].push(
                {
                    duration:0.01,
                    vars:{
                        x:0,
                        y:0,
                        rotation:0,
                        ease:Linear.easeNone
                    },
                }
            );
            this.leaveTweensData[1].push(
                {
                    duration:0.292,
                    vars:{
                        rotation:-0.262,
                        ease:Sine.easeInOut
                    },
                }
            );
            this.leaveTweensData[1].push(
                {
                    duration:2.312,
                    vars:{
                        bezier:{
                            curviness:1.25,
                            values:[
                                {x:0,y:0},
                                {x:-95,y:-366},
                                {x:350,y:-940},
                                {x:-617,y:-2080}
                            ],
                            autoRotate:["x","y","rotation",90*Math.PI/180,true],
                            scaleX:2,
                            scaleY:2
                        },
                        ease:Power1.easeIn
                    },
                }
            );
            //============flight path 3=================
            this.leaveTweensData[2].push(
                {
                    duration:0.01,
                    vars:{
                        x:0,
                        y:0,
                        rotation:0,
                        ease:Linear.easeNone
                    },
                }
            );
            this.leaveTweensData[2].push(
                {
                    duration:0.292,
                    vars:{
                        rotation:-0.066,
                        ease:Sine.easeInOut
                    },
                }
            );
            this.leaveTweensData[2].push(
                {
                    duration:2.312,
                    vars:{
                        bezier:{
                            curviness:1.25,
                            values:[
                                {x:0,y:0},
                                {x:-66,y:-635},
                                {x:-341,y:-1060},
                                {x:-705,y:-1217},
                                {x:-1200,y:-2080}
                            ],
                            autoRotate:["x","y","rotation",90*Math.PI/180,true],
                            scaleX:2,
                            scaleY:2
                        },
                        ease:Power1.easeIn
                    },
                }                
            );
            //============flight path 4=================
            this.leaveTweensData[3].push(
                {
                    duration:0.01,
                    vars:{
                        x:0,
                        y:0,
                        rotation:0,
                        ease:Linear.easeNone
                    },
                }
            );
            this.leaveTweensData[3].push(
                {
                    duration:0.292,
                    vars:{
                        rotation:-0.028,
                        ease:Sine.easeInOut
                    },
                }
            );
            this.leaveTweensData[3].push(
                {
                    duration:2.312,
                    vars:{
                        bezier:{
                            curviness:1.25,
                            values:[
                                {x:0,y:0},
                                {x:-12,y:-378},
                                {x:-104,y:-1089},
                                {x:-308,y:-1600},
                                {x:-684,y:-2080}
                            ],
                            autoRotate:["x","y","rotation",90*Math.PI/180,true],
                            scaleX:2,
                            scaleY:2
                        },
                        ease:Power1.easeIn
                    },
                }                
            );
            //============flight path 5=================
            this.leaveTweensData[4].push(
                {
                    duration:0.01,
                    vars:{
                        x:0,
                        y:0,
                        rotation:0,
                        ease:Linear.easeNone
                    },
                }
            );
            this.leaveTweensData[4].push(
                {
                    duration:0.292,
                    vars:{
                        rotation:0.175,
                        ease:Sine.easeInOut
                    },
                }
            );
            this.leaveTweensData[4].push(
                {
                    duration:2.312,
                    vars:{
                        bezier:{
                            curviness:1,
                            values:[
                                {x:0,y:0},
                                {x:150,y:-480},
                                {x:-2080,y:-1200}
                            ],
                            autoRotate:["x","y","rotation",90*Math.PI/180,true],
                            scaleX:2,
                            scaleY:2
                        },
                        ease:Sine.easeIn
                    },
                }
            );
        }
    }
}
